import React, { useState } from "react";
import { Container } from "@material-ui/core";
import { Dimmer, Loader, Grid } from "semantic-ui-react";
import Moment from 'react-moment'
import { connect } from "react-redux";
import { getSingleDashboardModifyRequest } from "../../../../../Redux/Actions/dashboardActions";
function TerminationAccessTicketsModal({
  getSingleDashboardModifyRequest,
  match,
  ticket,
}) {
  useState(() => {
    const fd = new FormData();
    fd.append("term_id", match.params.id);
    getSingleDashboardModifyRequest(fd);
  });
  let modticket;
  ticket
    ? (modticket = (
        <Grid columns="equal">
          <Grid.Row>
            <Grid.Column>
              <h3>Person Terminated: {ticket[0].person_modified_name} </h3>
              
            </Grid.Column>
            <Grid.Column>
              <h3>Status: {ticket[0].access_status}</h3>
              
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <h3>Requested: <Moment date={ticket[0].created} format="MM/DD/YY HH:mm" /> </h3>
              
            </Grid.Column>
          </Grid.Row>
        </Grid>
      ))
    : (modticket = (
        <Dimmer active inverted>
          <Loader inverted>Loading</Loader>
        </Dimmer>
      ));
  return (
    <Container maxWidth="lg">      
      {modticket}
    </Container>
  );
}
const mapStateToProps = (state) => ({
  ticket: state.dashboard_tickets.dashboard_tickets,
});
export default connect(mapStateToProps, { getSingleDashboardModifyRequest })(
  TerminationAccessTicketsModal
);
